module.exports = __webpack_public_path__ + "static/media/18.d5e227ca.png";